import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";
import { sendVerify, verifyOtpEmail } from "../../api/userInfo";
import { BACKGROUND_VIDEO } from "../../shared/config";
import { cn } from "src/lib/utils";
import { useLoggedInUser } from "../../api/userInfo";
import { getLogOut } from "../../context/auth/auth_action";
import { AuthContext } from "../../context/auth/auth_context";
import Button from "src/components/ui/buttons";
import { useTranslation } from "react-i18next";

const Verify = () => {
  const { user, mutateUser } = useLoggedInUser();
  const { t } = useTranslation("main");
  const authContext = useContext(AuthContext);
  const { dispatch } = authContext;
  const [OTP, setOtp] = useState("");
  const [minutes, setMinutes] = useState(5);
  const [seconds, setSeconds] = useState(0);
  const [codeExpire, setCodeExpire] = useState(false);
  const [errorInput, setErrorInput] = useState(false);
  const [expire, setExpire] = useState(false);
  const navigate = useNavigate();
  const [referenceCode, setReferenceCode] = useState("");
  const [resendDisabled, setResendDisabled] = useState(true);
  const [isModalOpen, setModalOpen] = useState(true);

  const handleConfirm = async () => {
    setModalOpen(false);

    try {
      const response = await sendVerify({ email: user?.email });
      console.log("Verification successful:", response.data);
      setReferenceCode(response.data.reference_code);
    } catch (error) {
      console.error("Error verifying email:", error);
    } finally {
    }
  };

  const handleCancel = () => {
    getLogOut(dispatch);
  };

  const handleBack = () => {
    setModalOpen(true);
  };

  const resendOTP = async () => {
    setMinutes(4);
    setSeconds(59);
    setResendDisabled(true);
    setOtp("");
    const { verifyData, error } = await sendVerify({ email: user?.email });
    if (!error) {
      console.log(verifyData);
    } else {
      alert(error);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
      if (minutes === 0 && seconds === 0) {
        setCodeExpire(true);
      } else {
        setCodeExpire(false);
      }

      if (minutes === 4 && seconds === 0) {
        setResendDisabled(false);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const handleOnSubmit = async () => {
    const formData = {
      email: user?.email,
      otp: OTP,
    };
    const { data, error } = await verifyOtpEmail(formData);

    if (data?.detail === "Success.") {
      mutateUser().then((res) => {
        if (res.status === 200) {
          if (res?.data?.company?.length > 0) {
            window.location.href = "/";
          } else {
            navigate("/set-up-company");
          }
        }
      });
    } else if (error.response.data.detail === "OTP not found.") {
      setErrorInput(error.response.data.detail);
      setExpire(true);
    } else {
      setErrorInput(error.response.data.detail);
      setExpire(true);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (expire) {
        setErrorInput(false);
        setExpire(false);
      }
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, [expire]);

  return (
    <div>
      <video
        autoPlay
        loop
        muted
        className="fixed z-0 w-auto min-w-full min-h-full max-w-none"
      >
        <source src={BACKGROUND_VIDEO} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <ConfirmationModal
        isOpen={isModalOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      {!isModalOpen && (
        <>
          <div className="absolute inset-0  w-auto min-w-full min-h-full opacity-0 bg-vekin max-w-none"></div>
          <div
            className={`absolute inset-0 z-20 flex items-center justify-center w-full h-screen overflow-hidden`}
          >
            <div className="max-w-sm p-4 mx-auto text-center bg-white rounded h-50 md:max-w-lg">
              <h1 className="text-3xl font-bold text-center text-vekin">
                {t("verify.title")}
              </h1>
              <div className="flex flex-col mt-4">
                <p>
                  {t("verify.info")}{" "}
                  <span className="font-bold">{user?.email}</span>
                </p>
                <p>{t("verify.description")}</p>
                <p>
                  {t("verify.expiration")}{" "}
                  {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
                {codeExpire && (
                  <span className="text-[12px] text-danger">
                    {t("verify.code_expired")}
                  </span>
                )}
              </div>

              <div className="mt-5">
                <p className="text-sm text-gray-500">
                  {t("verify.reference_code")} :{" "}
                  <span className="font-bold">{referenceCode}</span>
                </p>
              </div>

              <VerificationInput
                value={OTP}
                onChange={setOtp}
                autoFocus={false}
                placeholder=" "
                classNames={{
                  container: "ml-24 my-6 mt-1 sm:ml-6 md:ml-24",
                  character: "text-xl text-vekin rounded border-vekin",
                  characterInactive: " ",
                  characterSelected: " ",
                }}
              />
              {errorInput && (
                <span className="text-[12px] text-danger">{errorInput}</span>
              )}

              <div className="grid grid-cols-3 gap-12">
                <button
                  onClick={handleBack}
                  // onClick={handleSkip}
                  className="inline-flex items-center w-full gap-2 p-2 text-center border border-gray-300 rounded-md text-md text-vekin hover:shadow-md"
                >
                  <i className="ri-arrow-left-line"></i>
                  {t("verify.previous")}
                </button>
                <button
                  className={cn(
                    "inline-flex items-center w-full gap-2 py-2 text-center text-md text-grey",
                    { "text-vekin": !resendDisabled }
                  )}
                  // className={`inline-flex items-center w-full gap-2 py-2 text-center text-md  ${seconds > 0 || minutes > 0 ? 'text-grey' : 'text-vekin'}`}
                  // disabled={seconds > 0 || minutes > 0}
                  disabled={resendDisabled}
                  onClick={resendOTP}
                >
                  <i className="ri-restart-line"></i>
                  {t("verify.resend")}
                </button>
                <button
                  onClick={handleOnSubmit}
                  type="button"
                  className={`w-full py-2 text-white rounded focus:outline-none ${
                    OTP.length !== 6 ? "bg-gray-300" : "bg-vekin"
                  }`}
                  disabled={OTP.length !== 6}
                >
                  {t("verify.verify")}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default Verify;

const ConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation("main");
  return (
    <>
      <div className="absolute inset-0  w-auto min-w-full min-h-full opacity-0 bg-vekin max-w-none"></div>
      <div
        className={`absolute inset-0 z-20 flex items-center justify-center w-full h-screen overflow-hidden`}
      >
        <div className="max-w-sm p-4 mx-auto text-center bg-white rounded h-50 md:max-w-lg">
          <h1 className="text-3xl font-bold text-center text-vekin">
            {t("verify.title")}
          </h1>
          <p className="mt-2 text-gray-700"> {t("verify.continue")} </p>
          <p className=" text-gray-700">{t("verify.please_verify")}</p>
          <div className="flex justify-between p-4 gap-4 mt-10">
            <Button onClick={onCancel} danger>
              {t("verify.sign_out")}
            </Button>
            <Button primary onClick={onConfirm}>
              {t("verify.send_verification_code")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
